import { useState, useRef, useEffect } from 'react';
import { G } from './theme';
import { MODULES, PROOF, TESTIMONIALS, PRICING, TRAINERS } from './data';
import { HERO, LOGO, CERT } from './assets/images';
import IMGLG from './assets/imglg.png';
import FadeIn from './components/FadeIn';
import ModuleCard from './components/ModuleCard';
import SkillsModalitesTab from './components/SkillsModalitesTab';
import FAQSection from './components/FAQSection';
import PaymentMethods from './components/PaymentMethods';
import { getNextSessionMonthName } from './utils/nextSession';
import './styles/responsive.css';

export default function LandingPage() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", poste: "" });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [lightbox, setLightbox] = useState(null);
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const [priceTab, setPriceTab] = useState('CFA');
  const [trainerTab, setTrainerTab] = useState(0);
  const formRef = useRef(null);

  useEffect(() => {
    if (window.fbq) window.fbq('track', 'ViewContent');
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      setTestimonialIndex((i) => (i + 1) % TESTIMONIALS.length);
    }, 3000);
    return () => clearInterval(id);
  }, []);

  const scrollToForm = () => {
    if (window.fbq) window.fbq('track', 'InitiateCheckout');
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const SHEET_URL = "https://script.google.com/macros/s/AKfycbxhc8BN6qukCfu82_oWMBQRlJRtl-pH-4oi5ToBtH5CUMt5EywUQP4T9c-9vxI6q31Nrg/exec";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) { setError("Veuillez remplir votre nom et email."); return; }
    setError(""); setSubmitting(true);
    try {
      await fetch(SHEET_URL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: form.name, email: form.email, phone: form.phone, poste: form.poste }),
      });
      setSubmitted(true);
      if (window.fbq) window.fbq('track', 'Lead');
    } catch (err) {
      setError("Une erreur est survenue. Réessayez ou contactez-nous directement.");
    } finally {
      setSubmitting(false);
    }
  };

  const WA_URL = "https://wa.me/212772440393?text=Bonjour%2C%20je%20suis%20int%C3%A9ress%C3%A9(e)%20par%20le%20Certificat%20SIG%20AgriTech%20Academy";
  const nextSessionMonth = getNextSessionMonthName();

  return (
    <div style={{ fontFamily: "'DM Sans','Segoe UI',sans-serif", color: "#2C2C2A", lineHeight: 1.6, background: "#FAFAF8" }}>
      <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet" />

      {/* LIGHTBOX */}
      {lightbox !== null && (
        <div onClick={() => setLightbox(null)} style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(0,0,0,0.92)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, cursor: "zoom-out" }}>
          <div style={{ maxWidth: 960, width: "100%", textAlign: "center" }}>
            <img src={PROOF[lightbox].src} alt="" style={{ width: "100%", borderRadius: 12, maxHeight: "82vh", objectFit: "contain" }} />
            <p style={{ color: "rgba(255,255,255,0.6)", marginTop: 12, fontSize: 14 }}>{PROOF[lightbox].caption}</p>
          </div>
        </div>
      )}

      {/* NAV */}
      <nav className="lp-nav" style={{ position: "sticky", top: 0, zIndex: 100, background: "rgba(255,255,255,0.97)", backdropFilter: "blur(12px)", borderBottom: "1px solid #E8E8E4", padding: "0 32px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 64 }}>
        <img src={IMGLG} alt="AITAI AgriTech Academy" style={{ height: 40, width: "auto" }} />
        <button onClick={scrollToForm} style={{ background: G.g700, color: "#fff", border: "none", padding: "10px 22px", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
          S'inscrire →
        </button>
      </nav>

      {/* HERO */}
      <section style={{ position: "relative", minHeight: "92vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
        <img src={HERO} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", objectPosition: "center 30%", display: "block" }} />
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(180deg, rgba(4,52,44,0.68) 0%, rgba(8,80,65,0.76) 40%, rgba(4,52,44,0.9) 100%)" }} />
        <div style={{ position: "absolute", top: 24, right: 32, zIndex: 3 }}>
          <img src={LOGO} alt="AgriTech Academy" className="lp-hero-logo" />
        </div>
        <div style={{ position: "relative", zIndex: 2, textAlign: "center", padding: "0 24px", maxWidth: 860, width: "100%" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.3)", color: "#fff", fontSize: 13, fontWeight: 500, padding: "6px 18px", borderRadius: 24, marginBottom: 28 }}>
            🎓 Agritech Academy · l'agriculture de précision
          </div>
          <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: "clamp(2rem,5.5vw,3.8rem)", fontWeight: 700, color: "#fff", lineHeight: 1.15, marginBottom: 16 }}>
            Certificat Exécutif Avancé en SIG
          </h1>
          <h2 style={{ fontFamily: "inherit", fontSize: "clamp(1.4rem,3.5vw,2.4rem)", fontWeight: 600, lineHeight: 1.25, marginBottom: 24 }}>
            <span style={{ color: G.g400 }}>Data & Télédétection</span>
            <span style={{ color: "#fff" }}> pour l'Agriculture de Précision</span>
          </h2>
          <p style={{ fontSize: 17, color: "rgba(255,255,255,0.85)", maxWidth: 620, margin: "0 auto 36px", lineHeight: 1.8 }}>
            6 modules intensifs — QGIS, Google Earth Engine, imagerie drone thermique & multispectrale, IA agricole — avec un projet de certification sur exploitation réelle.
          </p>
          <div className="lp-hero-btns">
            <button onClick={scrollToForm} style={{ background: "#fff", color: G.g800, border: "none", padding: "15px 36px", borderRadius: 10, fontSize: 16, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", letterSpacing: "0.2px" }}>
              Réserver ma place
            </button>
            <a href="https://www.agtechm.com/fr/formations" target="_blank" rel="noreferrer"
              style={{ background: "transparent", color: "#fff", border: "2px solid rgba(255,255,255,0.5)", padding: "15px 30px", borderRadius: 10, fontSize: 15, fontWeight: 500, textDecoration: "none", display: "inline-flex", alignItems: "center" }}>
              Voir toutes nos formations →
            </a>
          </div>
        </div>
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 80, background: "linear-gradient(transparent, #FAFAF8)" }} />
      </section>

      {/* PROOF PHOTOS */}
      <section style={{ padding: "64px 24px", maxWidth: 1000, margin: "0 auto" }}>
        <FadeIn>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 6 }}>
            <div style={{ width: 4, height: 32, background: G.g600, borderRadius: 2 }} />
            <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "1.8rem", fontWeight: 700, margin: 0 }}>Vos formateurs en action</h2>
          </div>
          <p style={{ color: G.gray6, marginBottom: 28, fontSize: 15, paddingLeft: 16 }}>Captures réelles de nos sessions — pas des photos de stock</p>
        </FadeIn>
        <div className="lp-proof-grid">
          {PROOF.map((p, i) => (
            <FadeIn key={i} delay={i * 0.07}>
              <div onClick={() => setLightbox(i)}
                style={{ borderRadius: 13, overflow: "hidden", border: "1px solid #E4E4E0", cursor: "zoom-in", background: "#fff", transition: "transform 0.2s,box-shadow 0.2s" }}
                onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 8px 24px rgba(15,110,86,0.13)"; }}
                onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}>
                <div style={{ height: 180, overflow: "hidden", position: "relative" }}>
                  <img src={p.src} alt={p.caption} style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top" }} />
                  <div style={{ position: "absolute", top: 8, left: 8, background: G.g700, color: "#fff", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>{p.tag}</div>
                </div>
                <div style={{ padding: "10px 12px" }}>
                  <p style={{ fontSize: 12, color: G.gray6, lineHeight: 1.5, margin: 0 }}>{p.caption}</p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </section>

      {/* HOOK */}
      <section style={{ padding: "0 24px 56px", maxWidth: 800, margin: "0 auto" }}>
        <FadeIn>
          <div style={{ background: G.amberBg, borderLeft: `4px solid ${G.amber}`, borderRadius: "0 12px 12px 0", padding: "20px 24px" }}>
            <p style={{ fontSize: 15, color: G.gray8, margin: 0, lineHeight: 1.85 }}>
              <strong>Vous gérez des cultures mais prenez vos décisions sans données précises ?</strong><br />
              Sans SIG ni télédétection, vous ratez jusqu'à 30% de vos rendements potentiels. Ce certificat vous donne les outils des grandes agro-industries — QGIS, Pix4Dfields, Google Earth Engine, IA — pour cartographier, prévoir et optimiser chaque hectare.
            </p>
          </div>
        </FadeIn>
      </section>

      {/* MODULES */}
      <section style={{ padding: "0 24px 64px", maxWidth: 860, margin: "0 auto" }}>
        <FadeIn>
          <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 32 }}>
            <div style={{ width: 48, height: 48, borderRadius: "50%", border: `2px solid ${G.g700}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>🎓</div>
            <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "1.8rem", fontWeight: 700, margin: 0 }}>Les modules du certificat</h2>
          </div>
          <div style={{ borderTop: `1px solid #E4E4E0`, marginBottom: 8 }} />
        </FadeIn>
        <div className="lp-modules-box">
          {MODULES.map((m, i) => <ModuleCard key={i} m={m} idx={i} isLast={i === MODULES.length - 1} />)}
        </div>
        <FadeIn delay={0.1}>
          <div className="lp-cert-banner" style={{ background: `linear-gradient(135deg,${G.g800},${G.g700})` }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
              <span style={{ fontSize: 24 }}>🎓</span>
              <span style={{ fontWeight: 700, fontSize: 16 }}>Projet de Certification Finale</span>
            </div>
            {["Projet appliqué sur une exploitation réelle", "Analyse complète : irrigation, fertilisation, santé et rendement"].map((t, i) => (
              <div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start", marginBottom: 6 }}>
                <span style={{ color: G.g400, fontWeight: 600 }}>✓</span>
                <span style={{ fontSize: 14, color: "rgba(255,255,255,0.88)" }}>{t}</span>
              </div>
            ))}
          </div>
        </FadeIn>
      </section>

      {/* SKILLS + MODALITES TABS */}
      <section style={{ background: G.g100, padding: "56px 24px" }}>
        <div style={{ maxWidth: 860, margin: "0 auto" }}>
          <FadeIn>
            <SkillsModalitesTab />
          </FadeIn>
        </div>
      </section>

      {/* FORMATEUR */}
      <section style={{ padding: "64px 24px", maxWidth: 860, margin: "0 auto" }}>
        <FadeIn>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 32 }}>
            <div style={{ width: 4, height: 32, background: G.g600, borderRadius: 2 }} />
            <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "1.8rem", fontWeight: 700, margin: 0 }}>Vos formateurs</h2>
          </div>
        </FadeIn>
        <FadeIn delay={0.1}>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 20 }}>
            {TRAINERS.map((t, i) => (
              <button key={i} onClick={() => setTrainerTab(i)}
                style={{
                  padding: "8px 20px",
                  borderRadius: 8,
                  border: `1.5px solid ${trainerTab === i ? G.g600 : "#E4E4E0"}`,
                  background: trainerTab === i ? G.g600 : "#fff",
                  color: trainerTab === i ? "#fff" : G.gray6,
                  fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
                }}>
                {t.shortName}
              </button>
            ))}
          </div>
        </FadeIn>
        {(() => {
          const t = TRAINERS[trainerTab];
          return (
            <FadeIn key={trainerTab}>
              <div className="lp-trainer-card" style={{ background: "#fff", border: "1px solid #E4E4E0", borderRadius: 20, padding: "32px" }}>
                <div style={{ flexShrink: 0, position: "relative" }}>
                  <img src={t.img} alt={t.name}
                    className="lp-trainer-img" style={{ border: `4px solid ${G.g100}` }} />
                  <div style={{ position: "absolute", bottom: 4, right: 4, width: 28, height: 28, borderRadius: "50%", background: G.g700, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <span style={{ color: "#fff", fontSize: 14 }}>✓</span>
                  </div>
                </div>
                <div style={{ flex: 1, minWidth: 220 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: G.g600, letterSpacing: "0.6px", textTransform: "uppercase", marginBottom: 6 }}>{t.role}</div>
                  <h3 style={{ fontFamily: "'Playfair Display',serif", fontSize: "1.4rem", fontWeight: 700, color: G.g900, marginBottom: 6, lineHeight: 1.2 }}>
                    {t.name}
                  </h3>
                  <p style={{ fontSize: 14, color: G.gray6, lineHeight: 1.7, marginBottom: t.tags ? 8 : 20, maxWidth: 480 }}>
                    {t.bio}
                  </p>
                  {t.tags && (
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 20 }}>
                      {t.tags.map(tag => (
                        <span key={tag} style={{ background: G.g100, color: G.g700, fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>{tag}</span>
                      ))}
                    </div>
                  )}
                  <a href={t.linkedin} target="_blank" rel="noreferrer"
                    style={{ display: "inline-flex", alignItems: "center", gap: 10, background: "#0A66C2", color: "#fff", textDecoration: "none", padding: "10px 20px", borderRadius: 8, fontSize: 14, fontWeight: 600 }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
                    Voir le profil LinkedIn
                  </a>
                </div>
              </div>
            </FadeIn>
          );
        })()}
      </section>

      {/* CERTIFICATE */}
      <section style={{ background: "#fff", padding: "64px 24px" }}>
        <div style={{ maxWidth: 860, margin: "0 auto" }}>
          <FadeIn>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 6 }}>
              <div style={{ width: 4, height: 32, background: G.g600, borderRadius: 2 }} />
              <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "1.8rem", fontWeight: 700, margin: 0 }}>Un certificat international reconnu</h2>
            </div>
            <p style={{ color: G.gray6, fontSize: 15, marginBottom: 32, paddingLeft: 16 }}>
              À l'issue de la formation, vous recevez un certificat officiel délivré par AgriTech Academy · AITAI, reconnu dans 13+ pays africains.
            </p>
          </FadeIn>
          <FadeIn delay={0.1}>
            <div style={{ display: "flex", gap: 32, alignItems: "center", flexWrap: "wrap" }}>
              <div style={{ flex: "1 1 420px", borderRadius: 16, overflow: "hidden", border: "1px solid #E4E4E0", boxShadow: "0 8px 40px rgba(0,0,0,0.10)", position: "relative" }}>
                <img src={CERT} alt="Certificat International AgriTech Academy" style={{ width: "100%", display: "block" }} />
                <div style={{ position: "absolute", top: 14, left: 14, background: G.g700, color: "#fff", fontSize: 12, fontWeight: 600, padding: "4px 12px", borderRadius: 20 }}>
                  Exemple de certificat
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section style={{ background: G.g100, padding: "72px 24px" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto" }}>
          <FadeIn>
            <div style={{ textAlign: "center", marginBottom: 48 }}>
              <div style={{ fontSize: 12, fontWeight: 600, letterSpacing: "1.5px", textTransform: "uppercase", color: G.g600, marginBottom: 10 }}>
                Ce que disent nos apprenants
              </div>
              <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "clamp(1.6rem,3vw,2.2rem)", fontWeight: 700, margin: "0 0 12px" }}>
                800+ professionnels formés à travers l'Afrique
              </h2>
              <p style={{ color: G.gray6, fontSize: 15 }}>Des résultats concrets sur le terrain, pas des promesses</p>
            </div>
          </FadeIn>

          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 20 }}>
            {(() => {
              const t = TESTIMONIALS[testimonialIndex];
              return (
                <div key={testimonialIndex} style={{
                  background: "#fff",
                  borderRadius: 16,
                  padding: "24px",
                  border: "1px solid #E4E4E0",
                  display: "flex",
                  flexDirection: "column",
                  gap: 16,
                  boxSizing: "border-box",
                  maxWidth: 460,
                  width: "100%",
                }}>
                  {/* Stars */}
                  <div style={{ display: "flex", gap: 3 }}>
                    {Array(t.stars).fill(0).map((_, si) => (
                      <svg key={si} width="16" height="16" viewBox="0 0 24 24" fill={G.amber}><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" /></svg>
                    ))}
                  </div>
                  {/* Quote */}
                  <p style={{ fontSize: 14, color: G.gray8, lineHeight: 1.75, margin: 0 }}>
                    "{t.text}"
                  </p>
                  {/* Author */}
                  <div style={{ display: "flex", alignItems: "center", gap: 12, borderTop: "1px solid #F0F0EC", paddingTop: 16 }}>
                    <div style={{
                      width: 44, height: 44, borderRadius: "50%",
                      background: t.color,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      color: "#fff", fontWeight: 700, fontSize: 14, flexShrink: 0,
                    }}>
                      {t.initials}
                    </div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14, color: "#2C2C2A" }}>{t.name}</div>
                      <div style={{ fontSize: 12, color: G.gray6 }}>{t.role}</div>
                      <div style={{ fontSize: 12, color: G.g600, fontWeight: 500 }}>{t.flag} {t.country}</div>
                    </div>
                  </div>
                </div>
              );
            })()}
            <div style={{ display: "flex", gap: 8 }}>
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setTestimonialIndex(i)}
                  aria-label={`Voir le témoignage ${i + 1}`}
                  style={{
                    width: 8, height: 8, borderRadius: "50%", border: "none", padding: 0, cursor: "pointer",
                    background: i === testimonialIndex ? G.amber : "#D8D8D2",
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* LEAD FORM */}
      <section ref={formRef} id="inscription" style={{ background: `linear-gradient(135deg,${G.g900} 0%,${G.g700} 100%)`, padding: "72px 24px" }}>
        <div style={{ maxWidth: 540, margin: "0 auto", textAlign: "center" }}>
          <img src={LOGO} alt="AgriTech Academy" style={{ height: 80, width: "auto", marginBottom: 20, filter: "brightness(1.1)" }} />
          <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "2rem", fontWeight: 700, color: "#fff", marginBottom: 10 }}>Réservez votre place</h2>
          <p style={{ fontSize: 15, color: "rgba(255,255,255,0.78)", marginBottom: 16, lineHeight: 1.7 }}>
            Recevez le programme complet PDF, les dates et les tarifs — sans engagement.
          </p>

          {/* PRICE ANCHOR */}
          <div style={{ background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 12, padding: "20px 24px", marginBottom: 28, display: "inline-block", minWidth: 280 }}>
            <div style={{ fontSize: 12, fontWeight: 600, letterSpacing: "0.8px", textTransform: "uppercase", color: "rgba(255,255,255,0.5)", marginBottom: 14 }}>
              Tarif · Session {nextSessionMonth}
            </div>
            <div style={{ fontSize: "2rem", fontWeight: 700, color: G.g400, lineHeight: 1 }}>
              {PRICING.find(p => p.key === priceTab).price}
            </div>
            <div style={{ fontSize: 13, color: "rgba(255,255,255,0.55)", marginTop: 8, marginBottom: 16 }}>
              {PRICING.find(p => p.key === priceTab).region}
            </div>
            <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
              {PRICING.map(p => (
                <button key={p.key} onClick={() => setPriceTab(p.key)}
                  style={{
                    padding: "8px 20px",
                    borderRadius: 8,
                    border: "1px solid rgba(255,255,255,0.2)",
                    background: priceTab === p.key ? G.g400 : "rgba(255,255,255,0.06)",
                    color: priceTab === p.key ? G.g900 : "rgba(255,255,255,0.75)",
                    fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
                  }}>
                  {p.key}
                </button>
              ))}
            </div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", marginTop: 16, borderTop: "1px solid rgba(255,255,255,0.1)", paddingTop: 10 }}>
              💳 Paiement en 2 ou 3 fois sans frais disponible
            </div>
          </div>

          {submitted ? (
            <div style={{ background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 14, padding: "32px 24px" }}>
              <div style={{ fontSize: 44, marginBottom: 12 }}>✅</div>
              <div style={{ fontSize: 18, fontWeight: 600, color: "#fff", marginBottom: 8 }}>Demande reçue !</div>
              <div style={{ fontSize: 14, color: "rgba(255,255,255,0.75)" }}>Notre équipe vous contactera dans les 24h avec le programme détaillé et les prochaines dates disponibles.</div>
            </div>
          ) : (
            <form className="lp-form" onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {[
                { type: "text", placeholder: "Prénom et nom *", key: "name", required: true, autoComplete: "name" },
                { type: "email", placeholder: "Adresse email *", key: "email", required: true, autoComplete: "email" },
                { type: "tel", placeholder: "Téléphone / WhatsApp", key: "phone", required: false, autoComplete: "tel", inputMode: "tel" },
                { type: "text", placeholder: "Poste / Statut (ex: Agronome, Étudiant…)", key: "poste", required: false, autoComplete: "organization-title" },
              ].map(f => (
                <input key={f.key} type={f.type} placeholder={f.placeholder} value={form[f.key]} required={f.required}
                  autoComplete={f.autoComplete} inputMode={f.inputMode}
                  onChange={e => setForm({ ...form, [f.key]: e.target.value })}
                  style={{ padding: "14px 18px", borderRadius: 10, border: "1.5px solid rgba(255,255,255,0.22)", background: "rgba(255,255,255,0.1)", color: "#fff", fontSize: 15, fontFamily: "inherit", outline: "none", width: "100%", boxSizing: "border-box" }} />
              ))}
              {error && <div style={{ color: "#FAEEDA", fontSize: 13 }}>{error}</div>}
              <button type="submit" disabled={submitting}
                style={{ background: submitting ? "rgba(255,255,255,0.6)" : "#fff", color: G.g800, border: "none", padding: "15px 32px", borderRadius: 10, fontSize: 16, fontWeight: 700, cursor: submitting ? "not-allowed" : "pointer", fontFamily: "inherit", marginTop: 6 }}>
                {submitting ? "Envoi en cours..." : "👉 Réserver ma place →"}
              </button>
              <p style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginTop: 2 }}>Aucun spam. Données confidentielles. Zéro engagement.</p>
            </form>
          )}
        </div>
      </section>

      {/* FLOATING WHATSAPP */}
      <a href={WA_URL} target="_blank" rel="noreferrer"
        style={{ position: "fixed", bottom: 90, right: 20, zIndex: 999, width: 56, height: 56, borderRadius: "50%", background: "#25D366", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 4px 20px rgba(37,211,102,0.5)", textDecoration: "none" }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" /></svg>
      </a>

      {/* STICKY MOBILE CTA */}
      <div className="lp-sticky-cta">
        <button onClick={scrollToForm} style={{ flex: 1, background: G.g700, color: "#fff", border: "none", padding: "14px", borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
          Réserver ma place — {nextSessionMonth} →
        </button>
      </div>

      {/* PAYMENT METHODS */}
      <PaymentMethods />

      {/* FAQ */}
      <FAQSection />

      {/* FOOTER */}
      <footer style={{ background: G.g900, padding: "32px 24px", borderTop: "1px solid rgba(255,255,255,0.07)" }}>
        <div className="lp-footer-inner" style={{ maxWidth: 1000, margin: "0 auto" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <img src={LOGO} alt="AgriTech Academy" style={{ height: 50, width: "auto" }} />
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.35)", lineHeight: 1.5 }}>
              Académie Internationale des Technologies<br />d'Agriculture & d'Innovations
            </div>
          </div>
          <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
            {["support@agtechafrica.com", "+212 77 24 40 393", "www.agtechafrica.com"].map((c, i) => (
              <span key={i} style={{ fontSize: 13, color: "rgba(255,255,255,0.45)" }}>{c}</span>
            ))}
          </div>
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.25)" }}>© 2025 AgriTech Academy · AITAI</div>
        </div>
      </footer>
    </div>
  );
}
